import { render, staticRenderFns } from "./user_popover.vue.js?vue&type=template&id=6a03edae!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./user_popover.vue?vue&type=template&id=6a03edae"
import script from "./user_popover.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./user_popover.vue?vue&type=script&lang=js"
export * from "./user_popover.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./user_popover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/gitlab-gdk/gitlab-development-kit/gitlab/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a03edae')) {
      api.createRecord('6a03edae', component.options)
    } else {
      api.reload('6a03edae', component.options)
    }
    module.hot.accept("./user_popover.vue.js?vue&type=template&id=6a03edae!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./user_popover.vue?vue&type=template&id=6a03edae", function () {
      api.rerender('6a03edae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "vue_shared/components/user_popover/user_popover.vue"
export default component.exports